import React, { useState, useEffect, memo, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createConsumer } from "@rails/actioncable";

// antd
import { message } from "antd";

// Components
import MainTitle from "../components/MainTitle";
import TableInfo from "../components/TableInfo";
import EventInfo from "../components/EventInfo";
import JuryList from "../components/JuryList";
import SponsorList from "../components/SponsorList";
import VegModal from "../components/VegModal";
import ThankYouModal from "../components/ThankYouModal";

// API
import { externalBaseUrl } from "../utils/constant";
const websocketUrl = process.env.WEBSOCKET_URL;

// console.log(websocketUrl);

function Main() {
  const [searchParams] = useSearchParams();
  const uuid = searchParams.get("uuid");
  const navigate = useNavigate();

  // Comment for now
  const URL = `${websocketUrl}/cable?skip_auth=ok`;
  const consumer = useMemo(() => createConsumer(URL), [URL]);
  // console.log("consumer", consumer);

  const [userData, setUserData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showTyModal, setShowTyModal] = useState(false);

  // Comment for now
  useEffect(() => {
    // if (attendanceList && "list" in attendanceList) {
    consumer.subscriptions.create(
      {
        channel: "TicketMiipChannel",
        uuid: uuid,
      },
      {
        connected: () => console.log("connected"),
        disconnected: () => console.log("disconnected"),
        received: (data) => {
          console.log("received data", data);
          setUserData(data);
        },
      }
    );
    // }
    return () => {
      consumer.disconnect();
    };
  }, [userData, uuid, consumer]);

  useEffect(() => {
    if (searchParams.get("uuid")) {
      const getUserData = async () => {
        try {
          const res = await fetch(`${externalBaseUrl}/registrations/get`, {
            method: "POST",
            body: JSON.stringify({
              uuid: uuid,
            }),
            headers: {
              "Content-type": "application/json",
            },
          });
          const data = await res.json();
          if (data?.code === 406) {
            navigate("/page-not-found", {
              replace: true,
              state: { message: data?.message },
            });
          }
          setUserData(data?.data);
          setShowModal(data?.data?.prompt === "1");
        } catch (error) {
          message.error(error.message);
        }
      };

      getUserData();
    }
  }, [searchParams, navigate, uuid]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleCloseTyModal = () => {
    setShowTyModal(false);
  };

  return (
    <>
      <div className="container flex flex-col a-i-center j-c-center text-white">
        <MainTitle />
        <TableInfo userData={userData} />
        {/* <EventInfo /> */}
        {/* <JuryList /> */}
      </div>

      <SponsorList />

      <VegModal
        onShowModal={showModal}
        onHandleCloseModal={handleCloseModal}
        userId={uuid}
        onSetShowTyModal={setShowTyModal}
        onSetShowModal={setShowModal}
      />

      <ThankYouModal
        onShowModal={showTyModal}
        onHandleCloseModal={handleCloseTyModal}
      />
    </>
  );
}

export default memo(Main);
